// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"25477747","250":"aed7f4e4","252":"68a3c8e6","379":"cbd2a037","511":"46bf3ecc"}[chunkId] + ".chunk.js";
};